module.exports = __webpack_public_path__ + "8-d7489eb6.png";